import { cn } from "@/shared/utils";
import { VirtualItem } from "@tanstack/react-virtual";
import { forwardRef } from "react";

type VirtualTileProps = {
  virtualItem: VirtualItem;
} & React.ComponentProps<"div">;

export const VirtualTile = forwardRef<HTMLDivElement, VirtualTileProps>(
  ({ className, virtualItem, style, ...props }, ref) => (
    <div
      className={cn("!absolute w-full left-0", className)}
      style={{ top: virtualItem.start, ...style }}
      data-index={virtualItem.index}
      {...props}
      ref={ref}
    />
  )
);
